import UI from '/javascripts/utils/UI'
import bus from '/javascripts/bus'
import getScrollTop from '/javascripts/utils/getScrollTop'

UI({
  component: '.js-menu',
  mainGroups: ['.js-menu-mainGroup'],
  contentNav: '.js-menu-contentNav',
  mainLinks: ['.js-Menu-mainLink']
}, async ({ component, mainGroups, contentNav, mainLinks, toggleMenu }) => {
  await import('gsap/CSSPlugin')
  const TimelineLite = await import('gsap/TimelineLite').then(gsap => gsap.TimelineLite)
  const state = { scrollTop: 0, tl: null, isOpen: false }

  bus.on('toggleMenu', toggleMenu)

  mainLinks.forEach((link) => link.addEventListener('click', (event) => {
    // We use preventDefault() and event emmitting so we can manually update the hash in the URL for our React code
    // We need to do this in order to time code with animations
    // We only want to update the hash when this external (not React) code has finished
    // So React can do things correctly when the hash changes
    const hash = event.target.hash
    const currentPageIsHome = window.location.pathname === '/'

    if (hash && hash.startsWith('#') && currentPageIsHome) {
      event.preventDefault()
      bus.emit('closeMenu', hash)
    } else {
      bus.emit('closeMenu')
    }
  }))

  function toggleMenu(isOpen) {
    state.tl && state.tl.kill()
    state.tl = isOpen ? open() : close()
  }

  function open() {
    const tl = new TimelineLite({ onStart: beforeOpen, onComplete: afterOpen })
    tl.from(component, 0.475, { y: '-100%' })
    tl.staggerFrom(mainGroups, 0.225, { y: 40, opacity: 0 }, 0.1)
    tl.from(contentNav, 0.225, { y: '100%', opacity: 0 }, '-=0.450')
    tl.set([contentNav, ...mainGroups], { clearProps: 'all' })
    return tl
  }

  function close() {
    const tl = new TimelineLite({ onStart: beforeClose, onComplete: afterClose })
    tl.to(component, 0.275, { y: '-100%' })
    tl.set(component, { clearProps: 'all' })
    return tl
  }

  function beforeOpen() {
    document.body.style.overflow = 'hidden'
    component.classList.add('is-open')
    state.scrollTop = getScrollTop()
  }

  function afterOpen() {
    document.body.style.top = `-${state.scrollTop}px`
    document.body.classList.add('is-menu-open')
  }

  function beforeClose() {
    document.body.classList.remove('is-menu-open')
    document.body.style.top = ''
    window.scrollTo(0, state.scrollTop)
  }

  function afterClose() {
    document.body.style.overflow = ''
    component.classList.remove('is-open')
    document.body.classList.remove('is-drawer-open')
    bus.emit('menuAfterClose')
  }
})
